import { render, staticRenderFns } from "./ChooseFile.vue?vue&type=template&id=76e9e950&scoped=true&"
import script from "./ChooseFile.vue?vue&type=script&lang=js&"
export * from "./ChooseFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e9e950",
  null
  
)

export default component.exports